import React from 'react';
import { CountdownTimer } from './CountdownTimer';
import { CheckCircle2Icon } from 'lucide-react';
const CHECKOUT_URL = 'https://checkout.activapleno.com/cart/44423392297075:1';
const MAIN_IMG = 'https://cdn.magicpatterns.com/uploads/pb2oZ2RUzyQBkYMGwuGsQQ/Tomo_1.png';
const BONUS_IMGS = ['https://cdn.magicpatterns.com/uploads/1v1tHcyCreatuCmkt28rVw/bono_1.png', 'https://cdn.magicpatterns.com/uploads/vGHom5ujRe81NveL3u3iN1/bono_2.png', 'https://cdn.magicpatterns.com/uploads/7PtXNs7FzsdeptdeETMC52/bono_3.png', 'https://cdn.magicpatterns.com/uploads/brVZx9HsAREbCYwF2bHr3E/bono_4.png'];
export function OfferSection() {
  const savings = [{
    item: 'Mega-Pack Educazione Fisica (5 libri)',
    value: '$49,99 USD'
  }, {
    item: '50 Giochi Veloci per Educazione Fisica',
    value: '$9,99 USD',
    free: true
  }, {
    item: '30 Lezioni Complete di Educazione Fisica',
    value: '$12,99 USD',
    free: true
  }, {
    item: 'Schede di Valutazione Pronte da Stampare',
    value: '$7,99 USD',
    free: true
  }, {
    item: '40 Percorsi Motori Creativi',
    value: '$9,99 USD',
    free: true
  }];
  const totalValue = '$90,95 USD';
  return <section id="oferta" className="py-20 px-4 bg-gradient-to-b from-gray-50 to-white scroll-mt-20" data-id="element-95">
      <div className="max-w-4xl mx-auto" data-id="element-96">
        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border-2 border-green-500 relative" data-id="element-97">
          {/* Header */}
          <div className="bg-green-500 text-white text-center py-4" data-id="element-98">
            <h2 className="text-2xl font-bold uppercase tracking-wider" data-id="element-99">
              Accedi Ora al Mega-Pack
            </h2>
          </div>

          <div className="p-6 md:p-10" data-id="element-100">
            {/* Pack composite image */}
            <div className="flex items-end justify-center gap-1 mb-8" data-id="element-101">
              <img src={BONUS_IMGS[0]} alt="Bonus 1" className="w-[14%] rounded-md shadow-md transform -rotate-6" data-id="element-102" />
              <img src={BONUS_IMGS[1]} alt="Bonus 2" className="w-[16%] rounded-md shadow-lg transform -rotate-3" data-id="element-103" />
              <img src={MAIN_IMG} alt="Mega-Pack" className="w-[22%] rounded-lg shadow-xl z-10" data-id="element-104" />
              <img src={BONUS_IMGS[2]} alt="Bonus 3" className="w-[16%] rounded-md shadow-lg transform rotate-3" data-id="element-105" />
              <img src={BONUS_IMGS[3]} alt="Bonus 4" className="w-[14%] rounded-md shadow-md transform rotate-6" data-id="element-106" />
            </div>

            {/* Savings breakdown */}
            <div className="bg-gray-50 rounded-2xl p-6 mb-8 border border-gray-100" data-id="element-107">
              <h3 className="text-lg font-bold text-gray-900 mb-4 text-center" data-id="element-108">
                Ecco tutto quello che ricevi oggi:
              </h3>
              <div className="space-y-3" data-id="element-109">
                {savings.map((s, idx) => <div key={idx} className="flex items-center justify-between gap-3" data-id="element-110">
                    <div className="flex items-center gap-2 flex-1 min-w-0" data-id="element-111">
                      <CheckCircle2Icon className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-112" />
                      <span className="text-sm text-gray-700 truncate" data-id="element-113">
                        {s.item}
                      </span>
                      {s.free && <span className="bg-red-100 text-red-600 text-xs font-bold px-2 py-0.5 rounded flex-shrink-0" data-id="element-114">
                          GRATIS
                        </span>}
                    </div>
                    <span className={`text-sm font-medium flex-shrink-0 ${s.free ? 'text-gray-400 line-through' : 'text-gray-700'}`} data-id="element-115">
                      {s.value}
                    </span>
                  </div>)}
              </div>
              <div className="border-t border-gray-200 mt-4 pt-4 flex items-center justify-between" data-id="element-116">
                <span className="font-bold text-gray-900" data-id="element-117">Valore totale:</span>
                <span className="font-bold text-gray-400 line-through text-lg" data-id="element-118">
                  {totalValue}
                </span>
              </div>
            </div>

            {/* Price & Button */}
            <div className="text-center" data-id="element-119">
              <div className="mb-2" data-id="element-120">
                <p className="text-gray-500 text-base font-medium" data-id="element-121">
                  Prezzo originale:
                </p>
                <p className="text-2xl text-gray-400 line-through decoration-red-500 decoration-2 font-bold" data-id="element-122">
                  $49,99 USD
                </p>
              </div>

              <div className="mb-6" data-id="element-123">
                <p className="text-green-600 font-bold text-lg mb-1" data-id="element-124">
                  Prezzo speciale oggi:
                </p>
                <p className="text-5xl md:text-6xl font-extrabold text-gray-900" data-id="element-125">
                  $14,99 <span className="text-xl text-gray-500" data-id="element-126">USD</span>
                </p>
                <p className="text-green-600 font-bold text-sm mt-2" data-id="element-127">
                  Risparmi oltre il 70%!
                </p>
              </div>

              <div className="mb-6" data-id="element-128">
                <div className="flex justify-center mb-3" data-id="element-129">
                  <CountdownTimer data-id="element-130" />
                </div>
                <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="block w-full max-w-md mx-auto bg-green-600 hover:bg-green-500 text-white font-bold text-2xl py-6 px-8 rounded-2xl shadow-[0_10px_40px_rgb(22,163,74,0.4)] hover:shadow-[0_10px_40px_rgb(22,163,74,0.6)] transform hover:-translate-y-1 transition-all duration-300 animate-pulse-fast text-center" data-id="element-131">
                  ACQUISTA ORA
                </a>
              </div>

              <div className="flex flex-wrap justify-center gap-4 text-xs text-gray-500" data-id="element-132">
                <span data-id="element-133">🔒 Pagamento sicuro</span>
                <span data-id="element-134">⚡ Accesso immediato</span>
                <span data-id="element-135">🛡️ Garanzia 45 giorni</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}